/* istanbul ignore file */
enum PassFailUnableToTest {
  Pass = 'Pass',
  Fail = 'Fail',
  UnableToTest = 'UnableToTest',
}

export default PassFailUnableToTest;
